export function createBigNumbers(
  overview: any,
  formatCurrency: (value: number) => string
) {
  return [
    {
      title: 'Faturamento Total',
      description: 'Valor total faturado no período selecionado.',
      value: formatCurrency(overview.totalRevenue)
    },
    {
      title: 'Total de Vendas',
      description: 'Quantidade de vendas realizadas no período selecionado.',
      value: overview.salesCount
    },
    {
      title: 'Ticket Médio',
      description: 'Valor médio por venda realizada no período selecionado.',
      value: formatCurrency(overview.averageTicket)
    },
    {
      title: 'Produtos Cadastrados',
      description: 'Quantidade total de produtos cadastrados no sistema.',
      value: overview.registeredProducts
    },
    {
      title: 'Crescimento do Faturamento',
      description:
        'Percentual de crescimento em relação ao período anterior de mesma duração.',
      value: `${overview.revenueGrowthPercent}%`
    },
    {
      title: 'Crescimento das Vendas',
      description:
        'Percentual de crescimento em relação ao período anterior de mesma duração.',
      value: `${overview.salesCountGrowthPercent}%`
    }
  ];
}

export function generateTooltipHtml(
  item: {
    label: string;
    revenue: number;
    salesCount: number;
    growthPercent?: number;
  },
  showGrowth = false
): string {
  const formattedRevenue = formatCurrency(item.revenue);
  const growthClass = item.growthPercent! >= 0 ? 'text-success' : 'text-danger';

  const growthHtml =
    showGrowth && item.growthPercent !== undefined
      ? `
        <p>
          <strong>Crescimento:</strong>
          <span class="${growthClass}">
            ${item.growthPercent}%
          </span>
        </p>
      `
      : '';

  return `
    <div class="chart-tooltip">
      <div class="tooltip-header">
        <strong>${item.label}</strong>
      </div>

      <div class="tooltip-body">
        <p><strong>Faturamento:</strong> ${formattedRevenue}</p>
        <p><strong>Vendas:</strong> ${Math.trunc(item.salesCount)}</p>
        ${growthHtml}
      </div>
    </div>
  `;
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value || 0);
}
